<script lang="ts">
	import { DefaultNav } from "@hitit/new_ui/src";
	import { links, navigate } from "svelte-routing";
	import { t } from "@hitit/hub/src/stores";
	export let active: "username" | "password";

</script>

<div class="tabs" id="forgotTabs" use:links>
	<DefaultNav active={active === 'username'}>
		<span on:click={() => navigate('/forgotId')}>아이디 찾기</span>
	</DefaultNav>
	<div class="sepeartebar" />
	<DefaultNav active={active === 'password'}>
		<span on:click={() => navigate('forgotPassword')}>비밀번호 찾기</span>
	</DefaultNav>
</div>

<style lang="scss">
	:global(#forgotTabs .active) {
		font-weight: 600;
	}

	.tabs {
		width: 100%;
		display: flex;
		justify-content: space-evenly;
		margin-bottom: 29px;
		font-weight: 200;
	}
	.sepeartebar {
		width: 1px;
		height: 15px;
		background-color: #e6e7ed;
	}

</style>
